import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    flexShrink: 0,
    marginLeft: '10px'
  }
}));
